module.exports = __webpack_public_path__ + "static/media/enterprise.c38f9c72.jpg";